import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const WhatsAppContactContext = createContext(null);

export const WhatsAppContactProvider = ({ children }) => {
  const [matterNumber, setMatterNumber] = useState(null);
  const value = useMemo(() => ({ matterNumber, setMatterNumber }), [matterNumber]);
  return <WhatsAppContactContext.Provider value={value}>{children}</WhatsAppContactContext.Provider>;
};

export const useWhatsAppContact = () => useContext(WhatsAppContactContext);

// Pages call this with the matter number they display; it is cleared when they unmount.
// Without a provider (e.g. isolated page tests) it is a no-op.
export const useWhatsAppMatter = (matterNumber) => {
  const context = useContext(WhatsAppContactContext);
  const setMatterNumber = context?.setMatterNumber;
  useEffect(() => {
    if (!setMatterNumber) return undefined;
    setMatterNumber(matterNumber || null);
    return () => setMatterNumber(null);
  }, [matterNumber, setMatterNumber]);
};
